import { render, staticRenderFns } from "./InArticle.vue?vue&type=template&id=6e8c446c&"
import script from "./InArticle.vue?vue&type=script&lang=js&"
export * from "./InArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports